import { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';

import { Button } from '@pletly/ui';

interface Props {
	organisationUuid: string;
	teamUuid: string;
	type: 'caregivers' | 'careRecipients';
}
export const AssignButton = ({ organisationUuid, teamUuid, type }: Props) => {
	const { t } = useTranslation();
	const { navigate } = useNavigation();

	const handleAssignPress = useCallback(() => {
		navigate('AddMembersToTeam', { organisationUuid, teamUuid, type });
	}, [navigate, organisationUuid, teamUuid, type]);

	return (
		<Button variant="filled" color="primary" onPress={handleAssignPress} style={styles.button}>
			{t('assign')}
		</Button>
	);
};

const styles = StyleSheet.create({
	button: {
		alignSelf: 'flex-end',
	},
});
